/**
 * TODO: refactor to be 2 separate utils
 */
import { ISpecialOfferTypeEnum } from "@jti/magento";
export const getPromoButtonType = (specialPromo, isLoggedIn) => {
    if (!specialPromo)
        return "ADD_TO_CART" /* PROMO_BUTTON_TYPE.ADD_TO_CART */;
    const isEligible = specialPromo.eligible;
    const isPotentiallyEligible = specialPromo.potentially_eligible;
    if (isEligible && isLoggedIn) {
        return "ADD_TO_CART" /* PROMO_BUTTON_TYPE.ADD_TO_CART */;
    }
    if (!isEligible && isPotentiallyEligible && !isLoggedIn) {
        return "LOGIN" /* PROMO_BUTTON_TYPE.LOGIN */;
    }
    if (!isEligible && !isPotentiallyEligible) {
        return "SIMILAR_PRODUCTS" /* PROMO_BUTTON_TYPE.SIMILAR_PRODUCTS */;
    }
    return "NONE" /* PROMO_BUTTON_TYPE.NONE */;
};
export const getConditionalPurchaseOffer = (specialOffers) => {
    if (!specialOffers || specialOffers.length === 0) {
        return undefined;
    }
    const specialOffer = specialOffers.find((offer) => offer.type === ISpecialOfferTypeEnum.ConditionalPurchase);
    return specialOffer;
};
//# sourceMappingURL=useSpecialPromo.js.map